export default __webpack_public_path__ + "static/media/sore-throat.a1a7ca1e.png";